import { createMuiTheme } from '@material-ui/core';

export default createMuiTheme({
  overrides: {
    MuiCssBaseline: {
      '@global': {
        a: {
          '&:link': {
            color: '#949bda',
          },
          '&:visited': {
            color: '#656990',
          },
        },
      },
    },
  },
  palette: {
    background: {
      default: '#2D283E',
    },
    text: {
      primary: '#000',
    },
    primary: {
      main: '#2D283E',
    },
    secondary: {
      main: '#81E6D9',
    },
  },
  typography: {
    allVariants: {
      color: '#FFF',
    },
    body1: {
      color: '#D0D7E1',
    },
    caption: {
      color: '#D0D7E1',
    },
    fontFamily: 'Kanit, Roboto',
  },
});
